import without from 'lodash/without';
import Mark from '@patsnap/mark.js';
import EventEmitter from 'events';

export const highlightEventHub = new EventEmitter();

const excludeEles = ['mark', 'math *', 'maths *', 'svg', 'img'];

const markAsPromise = function (instance, keyword, opts = {}) {
    return new Promise(resolve => {
        let markType = keyword === undefined ? 'unmark' : 'mark';
        if (markType === 'unmark') {
            instance[markType]({ done: resolve });
        } else {
            instance[markType](keyword, Object.assign({ done: resolve }, opts));
        }
    });
};

/**
 * 隐形高亮，一般用于定位文本位置(不高亮)
 * @param {HTMLElement} dom
 * @param {String} str
 * @param {String} className
 * @returns {Promise<Mark>} Mark的实例
 */
export async function invisibleMark (dom, str, className) {
    const instance = new Mark(dom);
    if (str) {
        await markAsPromise(instance, str, {
            element: 'span',
            accuracy: 'partially',
            acrossElements: true,
            separateWordSearch: false,
            ignoreJoiners: true,
            className: className,
            exclude: without(excludeEles, 'mark')
        });
    }
    return instance;
}
